import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import { MarkTabs, InformationFlow, NormalSlides } from 'ThreeTerminal_mobile_dynamic';
import { getUrlSecretId } from '@Container/common/client/utils/utils';
import { getSpecificList, getRelateFeedList } from '../../../../services/api';
import { h5PageCount } from 'ThreeTerminal_utils';
import errorBoundary from '@ifeng/errorBoundary';

class AllLook extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        ad: PropTypes.object,
        bigPicSwiperData: PropTypes.array,
        wutongData: PropTypes.array,
        wxLaunch: PropTypes.object,
        isHitBlack: PropTypes.bool,
        isCloseAlgRec: PropTypes.bool,
    };

    state = {
        allLookDataArr: [],
        novelData: {},
    };

    arrayPropertyUnique = (arr = [], uniId = '') => {
        const obj = {};
        const tempArr = [];

        for (let i = 0; i < arr.length; i++) {
            if (!obj[arr[i][uniId]]) {
                tempArr.push(arr[i]);
                if (arr[i][uniId]) {
                    obj[arr[i][uniId]] = true;
                }
            }
        }

        return tempArr;
    };

    /**
     * 渲染网页布局
     */
    async componentDidMount() {
        const { content, isHitBlack, isCloseAlgRec } = this.props;
        const { relatedRecommend } = content;

        try {
            let data = [];
            let specificData = await getSpecificList(content.base62Id, 'share_relate_doc', 2);
            let manualData = [];

            if (relatedRecommend && Array.isArray(relatedRecommend) && relatedRecommend.length) {
                manualData = await getRelateFeedList(relatedRecommend);
            }
            specificData = specificData && Array.isArray(specificData) ? this.formalData(specificData) : [];
            manualData = manualData && Array.isArray(manualData) ? this.formalData(manualData, true) : [];

            if (isHitBlack || isCloseAlgRec) {
                data = manualData;
            } else {
                data = [...manualData, ...specificData];
            }
            data = this.arrayPropertyUnique(data, 'base62Id');

            this.setState({ allLookDataArr: data });
        } catch (e) {
            console.error(e);
        }
    }

    formalData(data, manual = false) {
        const { content, wutongData, wxLaunch } = this.props;
        const downloads = content.isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1453822840627',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8797',
              };
        const sliceData = manual ? data : data.slice(0, 3);
        let listDataArr = sliceData.map((item, index) => ({
            id: item.documentId || item.base62Id,
            _id: (item.link && item.link.weburl && getUrlSecretId(item.link.weburl)) || item.base62Id || '',
            title: item.title || '',
            url: (item.link && item.link.weburl) || item.url || '',
            isVideoShare: content.isVideoShare,
            type: 'doc',
            kind: 'share01',
            thumbnails: item.thumbnails
                ? item.thumbnails
                : {
                      image: [
                          {
                              bytes: 277,
                              width: '340',
                              url: item.thumbnail || '',
                              height: '188',
                          },
                      ],
                  },
            downloads,
            newstype: 'doc',
            allcount: 0,
            callUp: 1,
            clickCount: {
                behavior: 'action',
                type: 'click',
                other: {
                    to: item.documentId || item.commentsUrl,
                    ref: `ucms_${content.base62Id}`,
                    rnum: index + 1,
                    tag: 't7',
                    kind: 'article',
                    url: item.link && encodeURIComponent(item.link.weburl),
                },
            },
            wxLaunchType: wxLaunch.wxLaunchType,
            wxLaunchSwitch: wxLaunch.wxLaunchSwitch,
        }));

        // 十条数据随机一条
        const wutongDataRandom =
            wutongData && wutongData.length > 0 ? [wutongData[Math.floor(Math.random() * wutongData.length)]] : [];

        // 梧桐数据插入
        if (!manual && wutongDataRandom && wutongDataRandom.length > 0 && listDataArr && listDataArr.length > 0) {
            listDataArr = wutongDataRandom.concat(listDataArr).slice(0, 3);
        }

        return listDataArr;
    }
    novelHandle = url => {
        h5PageCount([
            {
                behavior: 'action',
                type: 'readnovel',
                other: {
                    ref: encodeURIComponent(document.referrer),
                    url: encodeURIComponent(location.href),
                    kind: 'other',
                },
            },
        ]);

        const isVideoShare =
            (typeof window === 'object' &&
                window.allData &&
                window.allData.docData &&
                window.allData.docData.isVideoShare) ||
            false;

        location.href = isVideoShare ? `https://ishare.ifeng.com/c/vs/${url.split('/').pop()}` : url;
    };
    clickSlideHandle = item => {
        h5PageCount([
            {
                behavior: 'action',
                type: 'readtoad',
                other: {
                    ref: encodeURIComponent(item.url),
                    kind: 'other',
                    tag: 't8',
                    rnum: item.id,
                },
            },
        ]);
    };

    render() {
        /**
         * 组件分发数据
         */
        const { allLookDataArr, novelData } = this.state;
        let { ad, bigPicSwiperData, isHitBlack } = this.props;
        const markTabsObj = {
            title: '大家都在看',
        };

        bigPicSwiperData = bigPicSwiperData.map(item => {
            return {
                ...item,
                domStr: 'bigPicSwiper',
            };
        });

        return (
            <section className={styles.allLook}>
                {allLookDataArr.length > 0 && <MarkTabs content={markTabsObj} />}
                {allLookDataArr.length > 0 && (
                    <InformationFlow isCount={false} content={allLookDataArr} isDisplayLoadingMore={false} ad={[ad]} />
                )}
                {!isHitBlack &&
                    bigPicSwiperData.length > 0 && (
                        <div className={styles.bigPicSwiper} id="bigPicSwiper">
                            <NormalSlides
                                content={bigPicSwiperData}
                                unitSize={375}
                                clickSlideHandle={this.clickSlideHandle}
                            />
                        </div>
                    )}
                {/* 小说位 */}
                {/* {novelData.title && (
                    <div className={styles.novelFeed} onClick={this.novelHandle.bind(this, novelData.url)}>
                        <div className={styles.novelFeedImg}>
                            <LazyImg
                                placeholder="https://x0.ifengimg.com/cmpp/2020/0414/60674ea2039d936size1_w180_h240.png"
                                src={novelData.image}
                                className={styles.novelFeedPic}
                            />
                        </div>
                        <div className={styles.novelFeedInfo}>
                            <h2 className={styles.novelFeedTitle}>{novelData.title}</h2>
                            <p className={styles.novelFeedPre}>{novelData.intro}</p>
                            <span className={styles.novelFeedMark} />
                        </div>
                    </div>
                )} */}
            </section>
        );
    }
}

export default errorBoundary(AllLook);
